// Backend API Client
// This is a mock implementation - replace with your actual API client

const createEntityMethods = (entityName) => ({
  list: async (sortBy = '-created_date', limit = 100) => {
    // Mock implementation - replace with actual API call
    console.log(`Fetching ${entityName} list with sort: ${sortBy}, limit: ${limit}`);
    return [];
  },
  get: async (id) => {
    console.log(`Fetching ${entityName} with id: ${id}`);
    return null;
  },
  create: async (data) => {
    console.log(`Creating ${entityName}:`, data);
    return { id: Date.now(), ...data };
  },
  update: async (id, data) => {
    console.log(`Updating ${entityName} ${id}:`, data);
    return { id, ...data };
  },
  delete: async (id) => {
    console.log(`Deleting ${entityName} ${id}`);
    return { success: true };
  },
});

export const backendApi = {
  auth: {
    me: async () => {
      // Mock user data - replace with actual API call
      return {
        id: 1,
        full_name: 'Demo User',
        email: 'demo@example.com',
      };
    },
    login: async (credentials) => {
      console.log('Login:', credentials);
      return { success: true };
    },
    logout: async () => {
      console.log('Logout');
      window.location.href = '/';
    },
  },
  entities: {
    Job: createEntityMethods('Job'),
    Applicant: createEntityMethods('Applicant'),
    Submission: createEntityMethods('Submission'),
    Interview: createEntityMethods('Interview'),
    Placement: createEntityMethods('Placement'),
    BenchCandidate: createEntityMethods('BenchCandidate'),
    Target: createEntityMethods('Target'),
    Client: createEntityMethods('Client'),
    Vendor: createEntityMethods('Vendor'),
  },
};
